import { useState } from 'react';
import { getImageUrl } from '../utils/imageUrl';
import { useTranslation } from '../i18n';

interface IExpandableMediaGridProps {
  mediaUrls: string[];
  onImageClick: (url: string) => void;
}

const MAX_VISIBLE = 4;

const ExpandableMediaGrid = ({
  mediaUrls,
  onImageClick,
}: IExpandableMediaGridProps) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const visibleUrls = expanded ? mediaUrls : mediaUrls.slice(0, MAX_VISIBLE);
  const hiddenCount = mediaUrls.length - MAX_VISIBLE;

  return (
    <div
      className={`mb-2 ${visibleUrls.length === 1 ? '' : 'grid grid-cols-2 gap-2'} max-w-lg`}
    >
      {visibleUrls.map((url, idx) => (
        <button
          key={idx}
          type="button"
          onClick={() => onImageClick(getImageUrl(url) || url)}
          className="relative block cursor-pointer"
        >
          <img
            src={getImageUrl(url)}
            alt={`Media ${idx + 1}`}
            className="rounded-md w-full object-cover border border-gray-200 hover:opacity-90 transition-opacity"
          />
          {idx === 3 && hiddenCount > 0 && !expanded && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                setExpanded(true);
              }}
              className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-md text-white text-lg font-semibold hover:bg-black/60 transition-colors"
            >
              +{hiddenCount}
            </span>
          )}
        </button>
      ))}
      {expanded && hiddenCount > 0 && (
        <button
          type="button"
          onClick={() => setExpanded(false)}
          className="col-span-2 text-xs text-gray-500 hover:text-gray-700 py-1"
        >
          {t('common.show_less')}
        </button>
      )}
    </div>
  );
};

export default ExpandableMediaGrid;
